<div class="section" id="uslugi">
  <div class="container">
    <h2 class="title text-center d-none d-lg-block">
      Zabiegi fizjoterapeutyczne - jakie usługi są świadczone w gabinecie {{ company.NAME_COMPACT }}?
    </h2>
    <h2 class="title text-center d-lg-none">
      Zabiegi fizjoterapeutyczne<br/>
      Jakie usługi są świadczone w gabinecie<br/>
      {{ company.NAME_COMPACT }}?
    </h2>
    <hr class="section-hr reveal fade-width"/>
    <div class="row">
      <div class="col-lg-4">
        <div class="card card-profile">
          <div class="card-avatar reveal fade-scale-and-opacity">
            <img ngSrc="assets/services/konsultacja.webp" alt="Ilustracja konsultacji fizjoterapeutycznej"
                 width="120" height="120">
          </div>
          <div>
            <h3 class="card-title">
              <b>Konsultacja fizjoterapeutyczna</b>
            </h3>
            <h4 class="card-title">Dla kogo jest ten rodzaj wizyty?</h4>
            <p class="text-justify">
              Konsultacja fizjoterapeutyczna polega na <b>szczegółowym zapoznaniu się z problemem pacjenta</b>. Problemy
              te mogą dotyczyć bólu w danej konkretnej okolicy ciała lub dolegliwości występujących podczas różnych
              aktywności. <b>Bez względu na to</b>, czy odczuwasz ból w obrębie <b>kręgosłupa, rąk, głowy, nóg czy innej
              części ciała</b>, ten rodzaj wizyty jest właśnie dla <b>Ciebie</b>.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card card-profile">
          <div class="card-avatar reveal fade-scale-and-opacity">
            <img ngSrc="assets/services/powiez.webp" alt="Ilustracja terapii mięśniowo-powięziowej"
                 width="120" height="120">
          </div>
          <div>
            <h3 class="card-title">
              <b>Terapia mięśniowo-powięziowa</b>
            </h3>
            <h4 class="card-title">Dla kogo jest ten rodzaj wizyty?</h4>
            <p class="text-justify">
              Z tego typu terapii może skorzystać każdy pacjent. Ponieważ większość z nas zmaga się z nawracającymi
              bólami lub tymi, które towarzyszą nam każdego dnia, terapia powięziowa przychodzi tutaj z pomocą.
              Znalezienie źródła problemu jest w tym wypadku kluczowe, aby skutecznie usprawnić ruch oraz podstawowe
              funkcje, a co najważniejsze - pozbyć się bólu.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card card-profile">
          <div class="card-avatar reveal fade-scale-and-opacity">
            <img ngSrc="assets/services/igly.webp" alt="Ilustracja suchego igłowania" width="120" height="120">
          </div>
          <div>
            <h3 class="card-title">
              <b>Suche igłowanie</b>
            </h3>
            <h4 class="card-title">Dla kogo jest ten rodzaj wizyty?</h4>
            <p class="text-justify">
              Suche igłowanie to technika przeznaczona dla osób z nadmiernie napiętymi mięśniami, które powodują
              dolegliwości bólowe zarówno podczas spoczynku, jak i podczas ruchu. Pozwala w skuteczny sposób opracować
              blizny pooperacyjne czy pobudzić czucie w odnerwionych obszarach, np. po zabiegach. W gabinecie
              {{ company.NAME_COMPACT }} wykonuję również suche igłowanie pod kontrolą USG.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <div class="card card-profile">
          <div class="card-avatar reveal fade-scale-and-opacity">
            <img ngSrc="assets/services/masaz.webp" alt="Ilustracja leczenia bólu kręgosłupa"
                 width="120" height="120">
          </div>
          <div>
            <h3 class="card-title">
              <b>Leczenie bólu kręgosłupa</b>
            </h3>
            <h4 class="card-title">Dla kogo jest ten rodzaj wizyty?</h4>
            <p class="text-justify">
              Leczenie bólu kręgosłupa jest dla osób zmagających się z występującym bólem kręgosłupa lub z przewlekłymi
              nawracającymi dolegliwościami w jego obrębie. Do dysfunkcji kręgosłupa również możemy zaliczać bóle
              promieniujące do kończyn, drętwienia, mrowienia, uczucie permanentnego napięcia okolicy ciała.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card card-profile">
          <div class="card-avatar reveal fade-scale-and-opacity">
            <img ngSrc="assets/services/terapia-manualna.webp" alt="Ilustracja terapii manualnej"
                 width="120" height="120">
          </div>
          <div>
            <h3 class="card-title">
              <b>Fizjoterapia bólu mięśni i stawów</b>
            </h3>
            <h4 class="card-title">Dla kogo jest ten rodzaj wizyty?</h4>
            <p class="text-justify">
              Dla osób, które doświadczają ograniczeń ruchowych w stawach oraz dla osób, które chcą efektywnie
              funkcjonować w pracy czy poza nią, bez dolegliwości bólowych. Niejednokrotnie jest to uporczywy ból
              kłujący, promieniujący, ciągnący. Drętwienie podczas wykonywania czynności lub spoczynku.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card card-profile">
          <div class="card-avatar reveal fade-scale-and-opacity">
            <img ngSrc="assets/services/trening.webp" alt="Ilustracja treningu rehabilitacyjnego"
                 width="120" height="120">
          </div>
          <div>
            <h3 class="card-title">
              <b>Rehabilitacja sportowa i leczenie kontuzji</b>
            </h3>
            <h4 class="card-title">Dla kogo jest ten rodzaj wizyty?</h4>
            <p class="text-justify">
              Dla wszystkich, którzy doznali urazu podczas aktywności fizycznej – od amatorów sportu po osoby aktywne na
              co dzień. Jako doświadczony <b>fizjoterapeuta w Gliwicach</b>, oferuję skuteczną terapię manualną i
              indywidualnie dobrane ćwiczenia rehabilitacyjne, które pomogą Ci wrócić do pełnej sprawności.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-4">
        <div class="card card-profile">
          <div class="card-avatar reveal fade-scale-and-opacity">
            <img ngSrc="assets/services/nmdt.webp" alt="Ilustracja diagnostyki nerwowo-mięśniowej"
                 width="120" height="120">
          </div>
          <div>
            <h3 class="card-title">
              <b>Rehabilitacja po artroskopii i operacjach stawów</b>
            </h3>
            <h4 class="card-title">Dla kogo jest ten rodzaj wizyty?</h4>
            <p class="text-justify">
              Szczególnie dla pacjentów, którzy przebyli zabieg operacyjny. Bardzo często u takich pacjentów wymagana
              jest praca nad zakresem ruchu w stawie, nauka prawidłowego wzorca ruchu, drenaż obrzęku, czy zażegnanie
              dolegliwości bólowych związanych z zabiegiem.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
